/* eslint-disable @typescript-eslint/no-deprecated */

import * as React from 'react'
import styled from 'styled-components'
import { DescriptionOutlined } from '@mui/icons-material'
import { Text } from '../../styles'

interface ResourceLinkProps {
  linkText?: string
  additionalText?: string
  resourceURL: string
}

export const ResourceLink: React.FC<ResourceLinkProps> = ({
  resourceURL,
  linkText = 'Further Information',
  additionalText,
}) => (
  <Link href={resourceURL} target="_blank" rel="noopener">
    <Icon />
    <Description as="p">{linkText}</Description>
    {additionalText || <Text>{additionalText}</Text>}
  </Link>
)

const Link = styled.a`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  color: ${({ theme }) => theme.colors.primary.medium};
  margin-bottom: 3rem;
`

const Icon = styled(DescriptionOutlined)`
  width: 2.4rem !important;
  height: 2.4rem !important;
  margin-right: 1rem;
`

const Description = styled(Text)`
  color: ${({ theme }) => theme.colors.primary.medium};
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary.medium};
  margin-bottom: 0;
`
